
export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/b3184c24f8d11d152b7cee190b431c1a.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center relative z-10">
        <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 font-['Pacifico',serif]">
          COOKIE DOO VRANJE
        </h1>
        <p className="text-2xl md:text-3xl text-white mb-8 max-w-3xl mx-auto">
          Secure Your Digital Life with Our Advanced VPN Solution
        </p>
        <p className="text-lg md:text-xl text-white/90 mb-12 max-w-2xl mx-auto">
          Experience ultimate online privacy and security with our cutting-edge VPN technology. Browse safely, access content freely, and protect your data from anywhere in the world.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="#contact" 
            className="whitespace-nowrap cursor-pointer bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Get Started
          </a>
          <a 
            href="#features" 
            className="whitespace-nowrap cursor-pointer bg-white/10 hover:bg-white/20 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 backdrop-blur-sm border-2 border-white/30"
          >
            Learn More
          </a>
        </div>
      </div>
    </section>
  );
}
